import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  closestCenter,
  DndContext,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import SortableItem from "../../../shared-components/SortableItem";
import { QuestionAccordion } from "./QuestionAccordion";

export const SortableQuestionList = ({
  questions,
  onQuestionEditClicked,
  onCheckBoxClick,
  onRemoveClicked,
}) => {
  const [orderedQuestions, setOrderedQuestions] = useState([]);

  useEffect(() => {
    setOrderedQuestions(questions);
  }, [questions]);

  useEffect(() => {
    setOrderedQuestions((prevOrdered) => {
      const existingIds = new Set(prevOrdered.map((q) => q.id));

      // Keep existing questions in same order
      const updatedOrdered = prevOrdered.filter((q) =>
        questions.some((newQ) => newQ.id === q.id),
      );

      // Append new questions at the end
      const newQuestions = questions.filter((q) => !existingIds.has(q.id));

      return [...updatedOrdered, ...newQuestions];
    });
  }, [questions]);
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8,
      },
    }),
  );

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (active.id !== over.id) {
      setOrderedQuestions((prevItems) => {
        const oldIndex = prevItems.findIndex((item) => item.id === active.id);
        const newIndex = prevItems.findIndex((item) => item.id === over.id);
        const updatedItems = arrayMove(prevItems, oldIndex, newIndex);

        return updatedItems.map((item, index) => ({
          ...item,
          id: (index + 1).toString(),
        }));
      });
    }
  };
  return (
    <DndContext
      collisionDetection={closestCenter}
      onDragEnd={handleDragEnd}
      sensors={sensors}
    >
      {" "}
      <SortableContext
        items={orderedQuestions.map((question) => question.id)}
        strategy={verticalListSortingStrategy}
      >
        {orderedQuestions.map((question, index) => (
          <SortableItem key={index} id={question.id}>
            <Grid size={12} key={index} sx={{ mt: 2 }}>
              <QuestionAccordion
                question={question}
                number={index + 1}
                onEditClicked={onQuestionEditClicked}
                onRemoveClicked={onRemoveClicked}
                onCheckBoxClick={onCheckBoxClick}
              />
            </Grid>
          </SortableItem>
        ))}
      </SortableContext>
    </DndContext>
  );
};
